/**
 * Convert a snake_case, kebab-case, or space-separated string into Title Case.
 *
 *   capitalize('gmail')         -> 'Gmail'
 *   capitalize('web_form')      -> 'Web form'
 *   capitalize('smtp_inbound')  -> 'Smtp inbound'
 *
 * Only the first word is uppercased to match UI copy style ("Web form", not
 * "Web Form"). Pass `allWords: true` for proper Title Case.
 */
export function capitalize(value, opts) {
    const words = value.replace(/[_-]+/g, ' ').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0)
        return '';
    if (opts?.allWords) {
        return words.map((w) => w[0].toUpperCase() + w.slice(1).toLowerCase()).join(' ');
    }
    const [head, ...rest] = words;
    return [
        head[0].toUpperCase() + head.slice(1).toLowerCase(),
        ...rest.map((w) => w.toLowerCase()),
    ].join(' ');
}
//# sourceMappingURL=capitalize.js.map